import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  Box,
  Button,
  Checkbox,
  Chip,
  FilledInput,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import DataTableItem from "react-data-table-component";
import localizationStrings from "../../utils/localizations";
import { baseUrl } from "../../utils/constants";
import { useLocation, useParams } from "react-router-dom";

export default function AyahList() {
  const [data, setData] = useState({ ayahs: [] });
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentSelected, setSelected] = useState(null);
  const [ayahNumber, setAyahNumber] = useState("");
  const [ayah, setAyah] = useState("");
  const [translationHi, setTranslationHi] = useState("");
  const [tafseer, setTafseer] = useState("");
  const [ruku, setRuku] = useState(0);
  const [modalLoading, setModalLoading] = useState(false);
  const location = useLocation();
  const [type, setType] = useState(0);
  const params = useParams();

  const handleOpen = (item) => {
    setSelected(item);
    setAyahNumber(item.ayah_num);
    setAyah(item.ayah_ar);
    setTranslationHi(item.translation_hi);
    setTafseer(item.tafseer_hi.join("\n\n"));
    setRuku(item.ruku);
    setModalVisible(true);
  };
  const handleClose = () => {
    setSelected(null);
    setAyahNumber("");
    setAyah("");
    setTranslationHi("");
    setTafseer("");
    setRuku(0);
    setModalVisible(false);
  };
  console.log(ayahNumber);

  const getSurahList = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const data = await axios.get(baseUrl + "quran/" + params.number + "?type=" + type);
      if (data.data.success) {
        console.log(data.data);
        setData(data.data.data);
        setFilteredData(data.data.data.ayahs);
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      console.warn(e);
    }
  };
  useEffect(() => {
    getSurahList();
    const int = setInterval(() => {
      getSurahList(true);
    }, 60 * 1000);
    return () => clearInterval(int);
  }, [type]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tp = queryParams.get("type");
    if (tp && tp !== type) {
      setType(tp);
    } else if (!tp) {
      window.location.href = window.location.href + "?type=0";
    }
  }, [location, type]);

  const pressSave = async () => {
    var currRuku = ruku;
    if (ruku == -1) {
      setRuku(0);
      currRuku = 0;
    }
    setModalLoading(true);
    try {
      const body = {
        ayah_num: ayahNumber,
        ayah_ar: ayah,
        translation_hi: translationHi,
        tafseer_hi: tafseer.split("\n\n"),
        ruku: currRuku,
      };
      // if (currentSelected) body["id"] = currentSelected.id;
      await axios.put(baseUrl + "quran/" + params.number + "/ayahs/" + currentSelected.ayah_num + "?type=" + type, body);
      await getSurahList(true);
      if (currentSelected.ayah_num != ayahNumber) {
        window.location.reload();
      }
      setModalLoading(false);
      handleClose();
    } catch (e) {
      setModalLoading(false);
      console.warn(e);
      alert("Error saving data\nError: " + (e?.response?.data?.message ?? e.message));
    }
  };

  if (loading) {
    return (
      <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="loader"></div>
      </div>
    );
  }

  const handleSearch = () => {
    setFilteredData(data.ayahs.filter((v) => JSON.stringify(v).toLocaleLowerCase().includes(search.toLocaleLowerCase())));
  };

  return (
    <div style={{ height: "calc(100vh - 60px)", width: "100%", padding: 30 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", mb: "15px" }}>
          {/* <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => setModalVisible(true)}> */}
          {/* <Button variant="contained" onClick={() => setModalVisible(true)}>
            {localizationStrings.Add}
          </Button> */}
          {/* </Box> */}
          <div style={{ flex: 1, display: "flex" }} />
          <Input
            style={{ backgroundColor: "#fff" }}
            placeholder={localizationStrings.Search}
            color="primary"
            value={search}
            onChange={(e) => setSearch(e.nativeEvent.target.value)}
            endAdornment={
              <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  onClick={() => {
                    setFilteredData(data.ayahs);
                    setSearch("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton type="submit" onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </Box>
            }
          />
        </Box>
      </form>
      {data.ayahs.length === 0 ? (
        <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
          <h3 style={{ textAlign: "center" }}>{localizationStrings.NoSurah}</h3>
        </div>
      ) : (
        <DataTableItem
          data={filteredData}
          columns={[
            {
              selector: (row) => (
                <div
                  onClick={() =>
                    process.env.NODE_ENV == "development"
                      ? window.open(
                          type == 0
                            ? "https://www.hindiislam.com/public/soratdetail_with_tafseerthree/" + params.number
                            : "https://www.hindiislam.com/public/soratdetail_with_tafseer/" + params.number
                        )
                      : null
                  }
                >
                  {row.ayah_num}
                </div>
              ),
              name: <div>{localizationStrings.Ayah_Num}</div>,
              sortable: true,
              grow: 0.1,
              wrap: true,
            },
            {
              selector: (row) => row.ayah_ar,
              name: <div>{localizationStrings.Ayah}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) => (
                <span>
                  {row.translation_hi.substr(0, 70)}
                  {row.translation_hi.length > 70 ? (
                    <span style={{ color: "#cc9767", cursor: "pointer" }} onClick={() => handleOpen(row)}>
                      {"  "} Read More
                    </span>
                  ) : null}
                </span>
              ),
              name: <div>{localizationStrings.Translation_HI}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) => (
                <div>
                  <br />
                  {row.tafseer_hi
                    .join("\n\n")
                    .substr(0, 70)
                    .split("\n")
                    .map((v, i, a) => (
                      <div>
                        {v}
                        {i == a.length - 1 && row.tafseer_hi.join("\n\n").length > 70 && (
                          <span style={{ color: "#cc9767", cursor: "pointer" }} onClick={() => handleOpen(row)}>
                            {"  "} Read More
                          </span>
                        )}
                        <br />
                      </div>
                    ))}
                  <br />
                </div>
              ),
              name: <div>{localizationStrings.Tafseer}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) => (row.ruku == 0 ? localizationStrings.None : row.ruku),
              name: <div>{localizationStrings.RukuEnded}</div>,
              sortable: true,
              grow: 0.2,
              wrap: true,
            },
            {
              selector: (row) => (
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" } }}>
                  {/* <Button variant='outlined' startIcon={<VisibilityIcon />}>
                  View
                </Button>
                <div style={{ width: 10, height: 10 }} /> */}
                  <Button style={{ color: "black" }} variant="outlined" startIcon={<EditIcon />} onClick={() => handleOpen(row)}>
                    {localizationStrings.Edit}
                  </Button>
                </Box>
              ),
              name: <div>{localizationStrings.Options || "Options"}</div>,
              sortable: true,
              grow: 2,
              wrap: true,
            },
          ]}
          highlightOnHover
          fixedHeader
          pagination
          responsive
          style={{ height: "calc(100vh - 82px)" }}
          customStyles={{
            headCells: { style: { backgroundColor: "#cc9767", color: "#000", fontSize: "11px" } },
            responsiveWrapper: { style: { height: "calc(100vh - 220px)" } },
            tableWrapper: { style: { width: "max(1000px, 100%)" } },
            cells: { style: { fontSize: "11px" } },
          }}
          paginationComponent={({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => (
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", minHeight: 56 }}>
              <Typography sx={{ margin: "0 24px", color: "rgba(0, 0, 0, 0.54)", fontSize: "13px" }}>
                {(currentPage - 1) * rowsPerPage + 1}-{currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage} of {rowCount}
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{ fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`, color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})` }}
                  onClick={() => onChangePage(1)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                    <path fill="none" d="M24 24H0V0h24v24z"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{ fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`, color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})` }}
                  onClick={() => onChangePage(currentPage - 1)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(currentPage + 1)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(Math.ceil(rowCount / rowsPerPage))}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                  </svg>
                </button>
              </div>
            </Box>
          )}
        />
      )}
      {modalVisible && (
        <div className="modal-container">
          <div aria-hidden="true" className="modal-back" onClick={handleClose}></div>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "70%", md: "60%", lg: "40%", xl: "30%" },
              maxHeight: "90%",
              overflowY: "scroll",
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Box sx={{ position: "absolute", top: 20, [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20 }}>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography id="modal-modal-description" sx={{ mt: 5, textAlign: "center", fontWeight: "700", fontSize: 18 }}>
              {currentSelected ? localizationStrings.Edit : localizationStrings.Add}
            </Typography>
            <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.Ayah_Num}
                variant="filled"
                value={ayahNumber}
                onChange={(e) => setAyahNumber(e.target.value)}
                type="number"
                onWheel={(e) => {
                  e.preventDefault();
                  // Blur input
                  e.target.blur();
                }}
              />
              <div style={{ height: 20 }} />
              <TextField label={localizationStrings.Ayah} variant="filled" value={ayah} onChange={(e) => setAyah(e.target.value)} />
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.Translation_HI}
                multiline
                minRows={2}
                variant="filled"
                value={translationHi}
                onChange={(e) => setTranslationHi(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.Tafseer}
                multiline
                minRows={3}
                variant="filled"
                value={tafseer}
                onChange={(e) => setTafseer(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <FormControl fullWidth variant="filled">
                <InputLabel id="demo-simple-select-label">{localizationStrings.RukuEnded}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={ruku != 0}
                  onChange={(e) => {
                    setRuku(e.target.value ? -1 : 0);
                  }}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>
              {ruku != 0 && <div style={{ height: 20 }} />}
              {ruku != 0 && (
                <TextField
                  label={localizationStrings.Ruku}
                  variant="filled"
                  value={ruku == -1 ? "" : ruku}
                  onChange={(e) => setRuku(e.target.value ? e.target.value : -1)}
                  type="number"
                />
              )}
              <div style={{ height: 20 }} />
              {modalLoading ? (
                <div style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                  <div className="loader" />
                </div>
              ) : (
                <Button onClick={() => pressSave()} variant="contained">
                  {localizationStrings.Save}
                </Button>
              )}
              <div style={{ height: 20 }} />
            </Box>
          </Box>
        </div>
      )}
    </div>
  );
}
